import { useRef } from 'react';

import { useToggle, IconButton, Dropdown, DropdownItem, TDropdownItem } from '@treezor/design-system';

import { TMenuAction, TActionMenuProps } from '@/ui-kit/action-menu/ActionMenu.types';

export function isMenuActions(actions: TMenuAction[] | TDropdownItem[]): actions is TMenuAction[] {
  return actions.every((action) => {
    return !!(action as TMenuAction)?.name;
  });
}

export function ActionMenu({ actions, className, isSelected, testId }: TActionMenuProps) {
  const iconButtonRef = useRef<HTMLButtonElement & HTMLAnchorElement>(null);

  let items: TDropdownItem[] = [];

  if (isMenuActions(actions)) {
    items = actions.map((action) => ({
      component: <DropdownItem label={action.label || action.text} icon={action.icon} onClick={action.onClick} />,
    }));
  } else {
    items = actions;
  }

  const [isDropdownOpen, toggleDropdown] = useToggle(false);

  return (
    <div className={className}>
      <IconButton
        ref={iconButtonRef}
        icon="more_vert"
        variant="secondary"
        isActive={isDropdownOpen}
        onClick={toggleDropdown}
        className={isSelected ? 'text-icon-onColor' : ''}
        testId={testId}
      />
      {isDropdownOpen && <Dropdown items={items} onClose={toggleDropdown} parentRef={iconButtonRef} overflow />}
    </div>
  );
}
